/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  getExternalWidth (index)
  {
    const VALUES = [ /* 0= */ 21, 32, 48, 60, 72, 96 /* 6= */ ];

    return VALUES[index];
  }


  getInternalWidth (index)
  {
    const VALUES = [ /* 0= */ 18, 28, 42, 54, 64, 84 /* 6= */ ];

    return VALUES[index];
  }


  getEntitySize (index)
  {
    const VALUES = [ /* 0= */ 0, 0, 18, 24, 28, 36 /* 6= */ ];

    return VALUES[index];
  }


  getUserBorderWidth (index)
  {
    const VALUES = [ /* 0= */ 1, 1.5, 1.5, 2, 2, 3 /* 6= */ ];

    return VALUES[index];
  }


  getSectorBorderWidth (index)
  {
    const VALUES = [ /* 0= */ 0, 1, 1, 1, 1, 1.25 /* 6= */ ];

    return VALUES[index];
  }


  getZoneBorderWidth (index)
  {
    const VALUES = [ /* 0= */ 0, 0, 0, 0.25, 0.25, 0.5 /* 6= */ ];

    return VALUES[index];
  }


  getDockBorderWidth (index)
  {
    const VALUES = [ /* 0= */ 0, 0.5, 0.5, 0.5, 1, 1.5 /* 6= */ ];

    return VALUES[index];
  }


};
